<template>
    <div class="campus-events">

        <div class="story__head">
            <h1 class="title title--dash">Campus Events</h1>
            <p>Our goal is to connect with students all across Canada in person and virtually to help showcase what ‘Living Our Purple’ really means. You can search below for upcoming events in your
                region
                or attend one of our National events to learn more! </p>
        </div>

        <div class="campus-events__search-bar">
            <campus-events-search></campus-events-search>
        </div>

        <div class="campus-events__container">
            <campus-events-list></campus-events-list>
        </div>

    </div>
</template>

<script>

import CampusEventsList from "@/components/CampusResources/CampusEvents/CampusEventsList";
import CampusEventsSearch from "@/components/CampusResources/CampusEvents/CampusEventsSearch";

export default {
    name: "CampusEvents",
    metaInfo: {
        title: 'Campus Events',
    },
    components: {
        CampusEventsSearch, 
        CampusEventsList,
    },
}
</script>
